var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M832.87 315.63c1.03-17.55-5.15-35.44-18.56-48.85L701.35 153.82c-11.62-15.67-30.26-25.83-51.27-25.83H256.83c-26.52 0-49.25 16.18-58.88 39.21a63.56 63.56 0 0 0-5.05 24.91V545h-24.88c-22.09 0-40 17.91-40 40v142.8c0 22.09 17.91 40 40 40h24.88v70.48h0.46c3.26 32.18 30.43 57.29 63.47 57.29h512.39v0.06c35.23 0 63.79-28.56 63.79-63.79V319.75c0.01-1.39-0.05-2.76-0.14-4.12zM362.31 732.81h-40.99l-23.98-45.75-23.98 45.75h-40.99l45.5-76.25-42.63-72.49h40.79l21.32 41.99 21.32-41.99h40.79l-42.63 72.49 45.48 76.25z m406.91 98.97H256.7V767.8h406.64c22.09 0 40-17.91 40-40V585c0-22.09-17.91-40-40-40H256.7V191.78h327.51v121.45c0 35.23 28.56 63.79 63.79 63.79h121.22v454.76z m-295-131.56v32.59h-97.15V584.08h35.87v116.14h61.28z m80.75-20.89c-1.84-1.88-4.92-3.34-9.63-3.97l-17.63-2.51c-12.91-1.88-22.75-6.27-29.31-13.16-6.76-7.1-10.04-17.13-10.04-29.87 0-27.16 20.09-47 53.29-47 20.91 0 36.69 5.01 49.19 17.76l-22.55 22.98c-9.22-9.4-21.32-8.77-27.67-8.77-12.5 0-17.63 7.31-17.63 13.79 0 1.88 0.62 4.6 2.87 6.89 1.84 1.88 4.92 3.76 10.04 4.39l17.63 2.51c13.12 1.88 22.55 6.06 28.69 12.32 7.79 7.73 10.86 18.8 10.86 32.59 0 30.29-25.62 46.79-56.36 46.79-22.34 0-40.58-4.18-55.34-19.64l22.96-23.4c7.58 7.73 20.91 10.44 32.59 10.44 14.14 0 20.91-4.8 20.91-13.37 0-3.54-0.82-6.47-2.87-8.77z m214.25-366.1H648V191.78h1.09l120.13 120.13v1.32z",
    fill: "#27AD36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M316.06 252.95h118.67v65.08H316.06zM464.59 252.95h65.08v65.08h-65.08zM316.06 337.85h118.67v65.08H316.06zM464.59 337.85h65.08v65.08h-65.08zM316.06 423h118.67v65.08H316.06zM464.59 423h65.08v65.08h-65.08z",
    fill: "#27AD36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXls);
export default __webpack_public_path__ + "static/media/xls.709804b1c89be827c0634b6f852d997d.svg";
export { ForwardRef as ReactComponent };